/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MarketplaceListingAlert } from '../model';
// @ts-ignore
import { MarketplaceListingAlertUserRequest } from '../model';
// @ts-ignore
import { MarketplaceListingAlerts } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * PublicMarketplaceAlertsApi - axios parameter creator
 * @export
 */
export const PublicMarketplaceAlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the alerts available for the User, broken into each Product. If the `user` field has data then they are the settings setup by the User, otherwise they haven\'t added any
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingAlertList: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/marketplace/listing/alert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or Update a User Alert
         * @param {string} listingAlertId 
         * @param {MarketplaceListingAlertUserRequest} marketplaceListingAlertUserRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingAlertUpdate: async (listingAlertId: string, marketplaceListingAlertUserRequest: MarketplaceListingAlertUserRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingAlertId' is not null or undefined
            assertParamExists('marketplaceListingAlertUpdate', 'listingAlertId', listingAlertId)
            // verify required parameter 'marketplaceListingAlertUserRequest' is not null or undefined
            assertParamExists('marketplaceListingAlertUpdate', 'marketplaceListingAlertUserRequest', marketplaceListingAlertUserRequest)
            const localVarPath = `/v2/marketplace/listing/alert/{listing_alert_id}`
                .replace(`{${"listing_alert_id"}}`, encodeURIComponent(String(listingAlertId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketplaceListingAlertUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicMarketplaceAlertsApi - functional programming interface
 * @export
 */
export const PublicMarketplaceAlertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicMarketplaceAlertsApiAxiosParamCreator(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the alerts available for the User, broken into each Product. If the `user` field has data then they are the settings setup by the User, otherwise they haven\'t added any
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingAlertList(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketplaceListingAlerts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingAlertList(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or Update a User Alert
         * @param {string} listingAlertId 
         * @param {MarketplaceListingAlertUserRequest} marketplaceListingAlertUserRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingAlertUpdate(listingAlertId: string, marketplaceListingAlertUserRequest: MarketplaceListingAlertUserRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketplaceListingAlert>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingAlertUpdate(listingAlertId, marketplaceListingAlertUserRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicMarketplaceAlertsApi - factory interface
 * @export
 */
export const PublicMarketplaceAlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicMarketplaceAlertsApiFp(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Returns all the alerts available for the User, broken into each Product. If the `user` field has data then they are the settings setup by the User, otherwise they haven\'t added any
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingAlertList(aaSource?: string, options?: any): AxiosPromise<MarketplaceListingAlerts> {
            return localVarFp.marketplaceListingAlertList(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or Update a User Alert
         * @param {string} listingAlertId 
         * @param {MarketplaceListingAlertUserRequest} marketplaceListingAlertUserRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingAlertUpdate(listingAlertId: string, marketplaceListingAlertUserRequest: MarketplaceListingAlertUserRequest, aaSource?: string, options?: any): AxiosPromise<MarketplaceListingAlert> {
            return localVarFp.marketplaceListingAlertUpdate(listingAlertId, marketplaceListingAlertUserRequest, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for marketplaceListingAlertList operation in PublicMarketplaceAlertsApi.
 * @export
 * @interface PublicMarketplaceAlertsApiMarketplaceListingAlertListRequest
 */
export interface PublicMarketplaceAlertsApiMarketplaceListingAlertListRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicMarketplaceAlertsApiMarketplaceListingAlertList
     */
    readonly aaSource?: string
}

/**
 * Request parameters for marketplaceListingAlertUpdate operation in PublicMarketplaceAlertsApi.
 * @export
 * @interface PublicMarketplaceAlertsApiMarketplaceListingAlertUpdateRequest
 */
export interface PublicMarketplaceAlertsApiMarketplaceListingAlertUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicMarketplaceAlertsApiMarketplaceListingAlertUpdate
     */
    readonly listingAlertId: string

    /**
     * 
     * @type {MarketplaceListingAlertUserRequest}
     * @memberof PublicMarketplaceAlertsApiMarketplaceListingAlertUpdate
     */
    readonly marketplaceListingAlertUserRequest: MarketplaceListingAlertUserRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicMarketplaceAlertsApiMarketplaceListingAlertUpdate
     */
    readonly aaSource?: string
}

/**
 * PublicMarketplaceAlertsApi - object-oriented interface
 * @export
 * @class PublicMarketplaceAlertsApi
 * @extends {BaseAPI}
 */
export class PublicMarketplaceAlertsApi extends BaseAPI {
    /**
     * Allow external IDs to be used for generic API views.
     * @summary Returns all the alerts available for the User, broken into each Product. If the `user` field has data then they are the settings setup by the User, otherwise they haven\'t added any
     * @param {PublicMarketplaceAlertsApiMarketplaceListingAlertListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceAlertsApi
     */
    public marketplaceListingAlertList(requestParameters: PublicMarketplaceAlertsApiMarketplaceListingAlertListRequest = {}, options?: any) {
        return PublicMarketplaceAlertsApiFp(this.configuration).marketplaceListingAlertList(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Create or Update a User Alert
     * @param {PublicMarketplaceAlertsApiMarketplaceListingAlertUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceAlertsApi
     */
    public marketplaceListingAlertUpdate(requestParameters: PublicMarketplaceAlertsApiMarketplaceListingAlertUpdateRequest, options?: any) {
        return PublicMarketplaceAlertsApiFp(this.configuration).marketplaceListingAlertUpdate(requestParameters.listingAlertId, requestParameters.marketplaceListingAlertUserRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
